<div class="flex items-center gap-3 cursor-pointer" #matMenuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="detailStyleMenu">
  <ig-expand-indicator #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="detailStyleMenu"
    aria-label="open"></ig-expand-indicator>
  <span [ngStyle]="{'color':textColor}">Itinerary details view style</span>
</div>

<mat-menu #detailStyleMenu="matMenu" class="ig-iti-details-style-menu">
  <div class="pb-2 pr-5 pl-4">
    <mat-radio-group class="flex flex-col" aria-label="Select an option" [(ngModel)]="currentItinerary.detailsStyle"
      igClickStopPropagation (change)="styleSelect()">
      <mat-radio-button value="map">Map</mat-radio-button>
      <!-- <mat-radio-button *ngIf="currentItinerary.hubName==='Savannah'" value="map3d" class="" igClickStopPropagation>
        3D Map
      </mat-radio-button> -->
      <mat-radio-button value="story" class="">Story telling</mat-radio-button>
    </mat-radio-group>
    <mat-checkbox class="mb-2" [(ngModel)]="applyToAll" igClickStopPropagation>Apply to all itineraries
    </mat-checkbox>

    <ig-button cls="w-full" (trigger)="setDetailsStyle($event, menuTrigger)" [isAsync]="true"
      successText="Update itinerary details view style successfully!" igClickStopPropagation>Save
    </ig-button>
    <p *ngIf="isShow3dMapTip" class="text-sm text-center text-gray-500 !mt-1">Save to load 3d map</p>
  </div>

</mat-menu>